export var FirebaseCollection;
(function (FirebaseCollection) {
    FirebaseCollection["Users"] = "users";
    FirebaseCollection["DynamicData"] = "dynamicData";
    FirebaseCollection["Games"] = "games";
    FirebaseCollection["Decks"] = "decks";
    FirebaseCollection["Cards"] = "cards";
    FirebaseCollection["RTDBInstances"] = "rtdbInstances";
})(FirebaseCollection || (FirebaseCollection = {}));
